import { render, staticRenderFns } from "./ModifyWordScorePepPopup.vue?vue&type=template&id=58efad78"
import script from "./ModifyWordScorePepPopup.vue?vue&type=script&lang=js"
export * from "./ModifyWordScorePepPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports